import React from 'react';

import PropTypes from 'prop-types';

import { Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

interface MainEntityDisplayCellProps {
  name: string;
  currentUserId: string;
  currentUserRoleId: string;
  currentUserCompanyId: string;
  property?: string;
  totalEntities: string[];
  stacked?: boolean;
  size?: SIZES;
}

const MainEntityDisplay: React.FC<MainEntityDisplayCellProps> = ({
  name,
  property,
  totalEntities,
  currentUserId,
  currentUserRoleId,
  currentUserCompanyId,
  stacked,
  size,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  const sizeStyle =
    size === SIZES.SMALL
      ? theme.typography.bodySmall
      : theme.typography.bodyMedium;

  const currentUserStyle =
    totalEntities.includes(currentUserId) ||
    totalEntities.includes(currentUserRoleId) ||
    totalEntities.includes(currentUserCompanyId)
      ? { ...sizeStyle, backgroundColor: theme.colors.adskBlue100 }
      : sizeStyle;

  return (
    <>
      <Text style={currentUserStyle}>{name}</Text>
      {totalEntities.length >= 2 ? (
        stacked ? (
          <>
            <br />
            <Text style={sizeStyle}>
              {T.translate('MORE_USERS', {
                count: totalEntities.length - 1,
              })}
            </Text>
          </>
        ) : (
          <Text style={sizeStyle}>
            {T.translate('MORE_USERS', {
              count: totalEntities.length - 1,
            })}
          </Text>
        )
      ) : (
        property &&
        (stacked ? (
          <>
            <br />
            <Text color="charcoal700" style={sizeStyle}>
              {property}
            </Text>
          </>
        ) : (
          <Text marginLeft="4px" style={sizeStyle}>
            ({property})
          </Text>
        ))
      )}
    </>
  );
};

MainEntityDisplay.displayName = 'SubmittalsMainEntityDisplay';
MainEntityDisplay.propTypes = {
  name: PropTypes.string.isRequired,
  property: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)).isRequired,
  stacked: PropTypes.bool,
};
MainEntityDisplay.defaultProps = {
  stacked: false,
  size: SIZES.MEDIUM,
};

export default MainEntityDisplay;
